export { default as MemberFilesPage } from "./MemberFilesPage";


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/member-files/index.js